import {
	BusinessMatterClientWithAssociations,
	PersonMatterClientWithAssociations,
} from '@models/matter';
import { PortalInvitee } from '@models/portal-invites';
import { getFullName } from '../../utilities/string';
import { clientsWithAssociations } from '../../clients/clients';

/**
 * Creates an array of PortalInvitee objects from an array of PersonMatterClientWithAssociations
 * @param clients Array of PersonMatterClientWithAssociations to transform
 * @param associationClients Array of associated clients
 * @returns Array of PortalInvitee objects
 */
export function createInviteesFromClients(
	clients: PersonMatterClientWithAssociations[],
	associationClients: (
		| PersonMatterClientWithAssociations
		| BusinessMatterClientWithAssociations
	)[],
): PortalInvitee[] {
	const clientsAssociations = clientsWithAssociations(
		clients,
		associationClients,
	);

	return clientsAssociations.map((client) => {
		const fullName = getFullName([
			client.firstName,
			client.middleNames,
			client.lastName,
		]);
		return {
			email: client?.email ?? '',
			sentHistory: [],
			clientId: client.id,
			name: fullName,
			displayName: fullName,
			isActive: true,
			inviteAccepted: false,
		};
	});
}
